export default __webpack_public_path__ + "static/media/2.3bad2dfe.webp";